import React, { useState, useEffect } from "react";
import axios from "./axios";
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";
const base_url = "https://image.tmdb.org/t/p/original";

function Row({ title, fetchUrl, islargeRow }) {
  const [trailerUrl, settrailerUrl] = useState("");
  const [movies, setmovies] = useState([""]);

  //a code that runs based on a funcions/variables
  useEffect(() => {
    //if [] , run once when the this function row loads but it doesnt self refresh

    async function fetchData() {
      const request = await axios.get(fetchUrl);
      setmovies(request.data.results);
      return request;
    }
    fetchData();
  }, [fetchUrl]);

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };
  const handleClick = (movie) => {
    console.log(movie.original_title);
    if (trailerUrl) {
      settrailerUrl("");
    } else {
      movieTrailer(movie?.original_title || "")
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          settrailerUrl(urlParams.get("v"));
        })
        .catch((error) => console.log(error));
    }
  };
  return (
    <div>
      <div className="row">
        {/*title*/}
        <h2>{title} </h2>
        <div className="row_posters">
          {movies.map((movie) => (
            <img
              onClick={() => handleClick(movie)}
              style={{
                borderRadius: "5px",
              }}
              key={movie.id}
              className={`row_poster ${islargeRow && "rowposter_large"}`}
              src={`${base_url}${
                islargeRow ? movie.poster_path : movie.backdrop_path
              }`}
              alt={movie.name}
            />
          ))}
          {/*container -> posters */}
        </div>
      </div>
      {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
    </div>
  );
}

export default Row;
